module.exports = "/packs/images/svg/ireland/facilities/pitches~0e947ca36cfdecb6d28157ab245e425a.svg";